<button [ngClass]="style"><ng-content></ng-content></button>
